import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'reactstrap';

const ReportCard = ({ block, onCardClick }) => {
  const { logo, title, description } = block;
  return (
    <div className='col-12 col-sm-6 col-xl-3 mb-3 pb-3'>
      <button className='btn w-100 h-100 p-0 m-0' onClick={onCardClick} type='button' data-cy={title}>
        <Card className='d-flex reports-card p-4 h-100'>
          <span className={`reports-card-icon fas ${logo} me-2 w-100 text-center mb-4 mt-3`} />
          <p className='w-100 text-center mb-4 fs-5'>{title}</p>
          <div style={{ lineHeight: 1.2 }}>{description}</div>
        </Card>
      </button>
    </div>
  );
};

ReportCard.propTypes = {
  block: PropTypes.object,
  onCardClick: PropTypes.func,
};

export default ReportCard;
